var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPosHub(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "shop",
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.124,
    height: 64.72,
    viewBox: "0 0 74.124 64.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_360",
    "data-name": "Group 360",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_326",
    "data-name": "Path 326",
    d: "M263.27,263.75H253.2a5,5,0,0,0-5,5v7.725a5,5,0,0,0,5,5H263.27a5,5,0,0,0,5-5v-7.725A5,5,0,0,0,263.27,263.75Zm1.363,12.723a1.367,1.367,0,0,1-1.363,1.363H253.2a1.367,1.367,0,0,1-1.363-1.363v-7.725a1.367,1.367,0,0,1,1.363-1.363H263.27a1.367,1.367,0,0,1,1.363,1.363Z",
    transform: "translate(-210.608 -228.505)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_327",
    "data-name": "Path 327",
    d: "M74.124,52.255a1.687,1.687,0,0,0-.242-.894L62.855,31.974a1.827,1.827,0,0,0-1.575-.924H12.829a1.8,1.8,0,0,0-1.575.924L.242,51.361A1.838,1.838,0,0,0,0,52.255a10.632,10.632,0,0,0,6.361,9.724V93.952A1.823,1.823,0,0,0,8.179,95.77H65.93a1.823,1.823,0,0,0,1.817-1.818V62.206a.8.8,0,0,0-.015-.2A10.662,10.662,0,0,0,74.124,52.255ZM13.889,34.7H60.22l8.618,15.161H5.286ZM52.753,53.482a6.985,6.985,0,0,1-13.752,0Zm-17.615,0a6.994,6.994,0,0,1-13.768,0Zm-31.382,0H17.524a6.994,6.994,0,0,1-13.768,0ZM30.534,92.135H20.083V72.52a2.589,2.589,0,0,1,2.59-2.59h5.286a2.589,2.589,0,0,1,2.59,2.59V92.135Zm33.578,0H34.169V72.52A6.234,6.234,0,0,0,27.944,66.3H22.658a6.235,6.235,0,0,0-6.225,6.225V92.15H10V62.872c.212.015.424.015.636.015a10.619,10.619,0,0,0,8.815-4.7,10.622,10.622,0,0,0,17.63,0,10.594,10.594,0,0,0,17.6,0,10.619,10.619,0,0,0,8.815,4.7c.212,0,.409-.015.621-.015V92.135Zm-.621-32.882A6.982,6.982,0,0,1,56.615,53.5H70.383A7.024,7.024,0,0,1,63.491,59.252Z",
    transform: "translate(0 -31.05)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosHub);
export default __webpack_public_path__ + "static/media/PosHub.4b80ad9c8993dc2e4ff690bd17181bdd.svg";
export { ForwardRef as ReactComponent };